import React, { useEffect } from 'react';
import SidebarTopbar from "../../components/layouts/layout";

export default function PubLibrary() {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes pulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.1); opacity: 0.8; }
        100% { transform: scale(1); opacity: 1; }
      }
      .coming-soon-badge {
        animation: pulse 2s infinite;
      }
      body {
        overflow: hidden;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <SidebarTopbar>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        backgroundColor: '#f5f5f5',
        overflow: 'hidden'
      }}>
        <div style={{
          background: 'white',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          padding: '2rem 1.5rem',
          maxWidth: '600px',
          width: '90%',
          textAlign: 'center',
          position: 'relative'
        }}>
          <div className="coming-soon-badge" style={{
            position: 'absolute',
            top: '-15px',
            right: '-15px',
            background: 'linear-gradient(45deg, #1E4DE3, #5c7fed)',
            color: 'white',
            padding: '0.4rem 0.8rem',
            borderRadius: '20px',
            fontSize: '0.8rem',
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }}>
            Coming Soon
          </div>

          <h1 style={{
            fontSize: '2.2rem',
            fontWeight: 700,
            margin: '0 0 0.8rem',
            background: 'linear-gradient(45deg, #1E4DE3, #5c7fed)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            color: 'transparent'
          }}>
            PubLibrary
          </h1>

          <p style={{
            color: '#666',
            fontSize: '1rem',
            lineHeight: '1.6',
            marginBottom: '1.5rem',
            textAlign: 'left'
          }}>
            PubLibrary is your intelligent research hub, built to keep you ahead in your therapy areas.
          </p>

          <div style={{
            textAlign: 'left',
            color: '#555',
            fontSize: '0.95rem',
            lineHeight: '1.6',
            marginBottom: '1.5rem'
          }}>
            <p>
              Stay Current, Automatically:Get the latest publications fetched and organized for you, without the manual effort.
            </p>

            <p>
              Your Library, Your Way:Upload your own documents and organize everything into project-based folders that match how you work.
            </p>

            <p>
              Turn Research into Action:Chat with your library to uncover insights and generate high-value assets, straight from your source material.
            </p>
          </div>

          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '1rem'
          }}>
          </div>
        </div>
      </div>
    </SidebarTopbar>
  );
}
